var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSelectModel = function SvgIconSelectModel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28.67,
    height: 28.67,
    x: 1.666,
    y: 1.665,
    fill: "#fff",
    rx: 14.335
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "M16 2.667C8.652 2.667 2.665 8.652 2.665 16c0 7.346 5.987 13.333 13.333 13.333 7.347 0 13.334-5.986 13.334-13.333S23.346 2.666 15.999 2.666Zm6.373 10.266-7.56 7.56a1 1 0 0 1-1.414 0L9.626 16.72a1.006 1.006 0 0 1 0-1.413 1.006 1.006 0 0 1 1.413 0l3.067 3.066 6.853-6.853a1.006 1.006 0 0 1 1.414 0 1.006 1.006 0 0 1 0 1.413Z"
  })));
};
export default SvgIconSelectModel;